import { FC, Fragment } from 'react'

import { BreadCrumbsProps } from './BreadCrumbsProps'

import * as SC from './styles'

export const BreadCrumbs: FC<BreadCrumbsProps> = ({ links }) => {
  const [last, ...rest] = [links.pop(), ...links]

  return (
    <SC.Container>
      {rest.map((link, index) => (
        <Fragment key={index}>
          <SC.PrevLink>{link}</SC.PrevLink>
          <SC.Arrow>/</SC.Arrow>
        </Fragment>
      ))}
      <SC.LastLink>{last}</SC.LastLink>
    </SC.Container>
  )
}
